export default function(VueInstance) {
  const breakWords = (string = '', maxLength = 20) => {
    return string.toString().replace(RegExp('(\\S{' + maxLength + '})(\\S)', 'g'), function(all, text, char) {
      return text + '\u200B' + char;
    });
  };

  VueInstance.filter('breakWords', breakWords);
}
